<router-outlet></router-outlet>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app.component.html